module.exports = __webpack_public_path__ + "static/PUCK_NEW_UJECIE_1v3v2-tablet-157567acb3213bdcf03b8c14306e5c20.jpg";